import { Err, Result } from '@/classes'
import { ITransaction } from '@/classes/Transaction'

export const transactionsGetAPI = async () => {
  const response: Result<{ transactions: ITransaction[] }> = await fetchAPI('transactions', {}, { method: 'POST' })

  if (!response.ok) return { error: response.error, data: null, ok: false } as Err

  return response
}

export const transactionsEventGetAPI = async (
  eventId: string,
  userId?: string
) => {
  const response: Result<{ transactions: ITransaction[] }> = await fetchAPI('transactions/event', { eventId, userId }, { method: 'POST' })

  if (!response.ok) return { error: response.error, data: null, ok: false } as Err

  return response
}

export const transactionsEventGetAllAPI = async (
  eventId: string
) => {
  const response: Result<{ transactions: ITransaction[] }> = await fetchAPI('transactions/event/all', { eventId }, { method: 'POST' })

  if (!response.ok) return { error: response.error, data: null, ok: false } as Err

  return response
}

export const transactionsCardRemoveAPI = async (
  cardId: string
) => {
  const response: Result<{ success: boolean }> = await fetchAPI('transactions/card/remove', { cardId }, { method: 'POST' })

  return response
}